/* globals $ $readMoreJS _ */
import { registerClass } from 'libs/ComponentLoader'
import queryString from 'query-string'
import 'libs/readMoreJS'

import { rcmShopifyApi } from 'libs/rcmShopifyApi'
import { PAGE_COMPONENTS_LOADED } from '_global/js/main'
import { OPTION_CHANGED } from 'components/VariantOptionSelector'

import './styles.scss'

class ProductInformation {
  constructor (element) {
    this.$el = $(element)
    this.readMoreJS = this.readMore()
    this.product = window.product

    this.quantityStepper = null
    this.variantOptionSelectors = []

    this.$variantSelect = this.$el.find('.productInformation-variantSelect')
    this.$addToCartForm = this.$el.find('.productInformation-productForm')
    this.$addtoCartButton = this.$el.find('.productInformation-addToCartButton')

    this.maxOrder = parseInt(this.$addToCartForm.attr('data-max-order'))

    this.$addToCartForm.on('submit', () => {
      this.addProductToCart()
      return false
    })

    $(document).on(PAGE_COMPONENTS_LOADED, (e) => {
      this.addToCartModal = $('[data-component="CartModal"]').data('component')
      this.$el.find('.variantOptionSelector').each((index, element) => {
        const variantOptionSelector = $(element).data('component')
        variantOptionSelector.$el.on(OPTION_CHANGED, this.variantOptionChanged.bind(this))
        this.variantOptionSelectors.push(variantOptionSelector)
      })
    })
  }

  addProductToCart () {
    const serializedFormData = this.$addToCartForm.serialize()
    const formData = queryString.parse(serializedFormData)

    rcmShopifyApi.addProduct(serializedFormData).then((responseData) => {
      const { productData, cartData } = responseData

      // update max quantity
      if (!this.quantityStepper) {
        this.quantityStepper = this.$el.find('.quantityStepper').data('component')
      }
      if (this.quantityStepper) {
        this.quantityStepper.adjustMaxQuantity(parseInt(formData.quantity))
      }
      if (productData.quantity >= this.maxOrder) {
        this.$addtoCartButton.prop('disabled', true)
      }

      this.addToCartModal.openModal({
        productData,
        cartData,
        formData
      })
    })
  }

  variantOptionChanged () {
    const variant = this.getVariantFromOptions()

    this.$el.addClass('productInformation--loading')
    window.location = `${window.location.origin}${window.location.pathname}?variant=${variant.id}`

    /* TODO: update variant without refreshing page */
    // this.updateVariant(variant)
  }

  updateVariant (variant) {
    /* TODO: update various items on the page */
  }

  /* Original function modified from debut theme.js */
  getCurrentOptions () {
    let currentOptions = $.map(
      this.variantOptionSelectors,
      function (selector) {
        return selector.selectedOption()
      }
    )

    return currentOptions
  }

  /* Original function modified from debut theme.js */
  getVariantFromOptions () {
    var selectedValues = this.getCurrentOptions()
    var variants = this.product.variants

    var found = _.find(variants, function (variant) {
      return selectedValues.every(function (values) {
        return _.isEqual(variant[values.index], values.value)
      })
    })

    return found
  }

  // ReadMore Button
  readMore (e) {
    $readMoreJS.init({
      target: '.productInformation-description',
      moreLink: 'view more',
      lessLink: 'view less',
      linkClass: 'description-button',
      containerClass: 'description-button-container'
    })
  }
}

registerClass('ProductInformation', ProductInformation)
